/* eslint-disable no-magic-numbers */

// 轴线，分割线
const LINE_COLOR = [0.4, 0.06];

type LineLevel = 1 | 2;

export const LINE_LEVEL_LIST: Record<string, LineLevel> = {
  LEVEL1: 1,
  LEVEL2: 2
};

export function lineColor(level: LineLevel, colorMode?: 'light' | 'dark') {
  const mode = colorMode || 'light';
  const color = mode === 'light' ? 0 : 255;
  return `rgba(${color}, ${color}, ${color}, ${LINE_COLOR[level - 1]})`;
}
